// extracted by mini-css-extract-plugin
export var baseButton = "_uv-0";
export var controlsArrowKeys = "_uv-1";
export var controlsResetButton = "_uv-2";
export var lightGameButton = "_uv-4 _uv-0";
export var playAgainButton = "_uv-5 _uv-0";
export var startGameButton = "_uv-3 _uv-0";